// import React, { useEffect, useState } from "react";
// import { Form } from "antd";
// import { useQueryState } from "nuqs";

// import TabsContain from "../../components/reuseComp/TabsContain";
// import { useMessageApi } from "../../../provider/AntdNotification";

// import { useAboutDataDetail, useAboutDataSave } from "../../../hooks/api/about/hooks";

// import AboutBanner from "./AboutBanner";
// import AboutIntro from "./AboutIntro";
// import WhyChooseUs from "./WhyChooseUs";
// import MissionSection from "./MissionSection";
// import VisionSection from "./VisionSection";

// const AboutTabs: React.FC<{ setBreadcrumb: (value: string) => void }> = ({
//   setBreadcrumb,
// }) => {
//   const message = useMessageApi();

//   const [tab, setTab] = useQueryState("tab");
//   const activeTab = tab || "Banner";

//   const [form] = Form.useForm();

//   const [isEditing, setIsEditing] = useState(false);
//   const [pageData, setPageData] = useState<any>(null);

//   const { data } = useAboutDataDetail();

//   const { mutate: saveAbout, isPending } = useAboutDataSave({
//     onSuccess: (res) => {
//       message.success("About page updated successfully");
//       setPageData(res.data);
//       setIsEditing(false);
//     },
//     onError: () => {
//       message.error("Failed to update About page");
//     },
//   });

//   useEffect(() => {
//     if (data?.data) {
//       setPageData(data.data);
//     }
//   }, [data]);

//   const handleChangeTab = (section: string) => {
//     setTab(section);
//     setIsEditing(false);
//     form.resetFields();
//     setBreadcrumb(section);
//   };

//   const handleSave = async () => {
//     try {
//       const values = await form.validateFields();

//       const payload = {
//         _id: pageData?._id,

//         banner: values.banner ?? pageData?.banner,
//         aboutIntro: values.aboutIntro ?? pageData?.aboutIntro,
//         whyChooseUs: values.whyChooseUs ?? pageData?.whyChooseUs,
//         mission: values.mission ?? pageData?.mission,
//         vision: values.vision ?? pageData?.vision,
//       };

//       saveAbout(payload);
//     } catch (err) {
//       console.log("Validation Error:", err);
//     }
//   };

//   const handleCancel = () => {
//     setIsEditing(false);
//     form.resetFields();
//   };

//   const sections = [
//     "Banner",
//     "About Intro",
//     "Why Choose Us",
//     "Mission",
//     "Vision",
//   ];

//   return (
//     <div>
//       <TabsContain
//         sections={sections}
//         activeTab={activeTab}
//         handleChangeTab={handleChangeTab}
//       />

//       {activeTab === "Banner" && (
//         <AboutBanner
//           bannerData={pageData?.banner || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleSave={handleSave}
//           handleCancel={handleCancel}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "About Intro" && (
//         <AboutIntro
//           aboutIntroData={pageData?.aboutIntro || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleSave={handleSave}
//           handleCancel={handleCancel}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Why Choose Us" && (
//         <WhyChooseUs
//           whyChooseUsData={pageData?.whyChooseUs || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleSave={handleSave}
//           handleCancel={handleCancel}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Mission" && (
//         <MissionSection
//           missionData={pageData?.mission || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleSave={handleSave}
//           handleCancel={handleCancel}
//           loading={isPending}
//         />
//       )}

//       {/* {activeTab === "Vision" && (
//         <VisionSection
//           visionData={pageData?.vision || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleSave={handleSave}
//           handleCancel={handleCancel}
//           loading={isPending}
//         />
//       )} */}
//     </div>
//   );
// };

// export default AboutTabs;



import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { useQueryState } from "nuqs";

import TabsContain from "../../components/reuseComp/TabsContain";
import { useMessageApi } from "../../../provider/AntdNotification";

import {
  useAllPageDetail,
  useAllPageSave,
} from "../../../hooks/api/allPages/hooks";

import { PageType } from "../../../types/api/allPages";

import AboutBanner from "./AboutBanner";
import AboutIntro from "./AboutIntro";
import WhyChooseUs from "./WhyChooseUs";
import MissionSection from "./MissionSection";
import VisionSection from "./VisionSection";

const sections = [
  "Banner",
  "About Intro",
  "Why Choose Us",
  "Mission",
  "Vision",
];

const AboutTabs: React.FC<{ setBreadcrumb: (value: string) => void }> = ({
  setBreadcrumb,
}) => {
  const message = useMessageApi();

  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Banner";

  const [form] = Form.useForm();

  const [isEditing, setIsEditing] = useState(false);
  const [pageData, setPageData] = useState<Record<string, any>>({});

  const pageType: PageType = "ABOUT";

  // ----------------------- Fetch Page -----------------------
  const { data, isFetching } = useAllPageDetail(pageType);

  // ----------------------- Save Page ------------------------
  const { mutate: savePage, isPending: isLoading } = useAllPageSave(pageType, {
    onSuccess: (res) => {
      message.success("About page updated successfully");
      setPageData(res.data?.data || {});
      setIsEditing(false);
    },
    onError: () => {
      message.error("Failed to update About page");
    },
  });

  useEffect(() => {
    if (data?.data) {
      setPageData(data.data?.data);
    }
  }, [data]);

  // ----------------------- Tab Handling ---------------------
  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  // ----------------------- Save -----------------------------
  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload: any = {
        _id: data?.data?._id,
        ...pageData,
        ...values,
      };


      savePage(payload);
    } catch (err) {
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  // ----------------------- Render ---------------------------
  return (
    <div>
      <TabsContain
        sections={sections}
        activeTab={activeTab}
        handleChangeTab={handleChangeTab}
      />

      {activeTab === "Banner" && (
        <AboutBanner
          bannerData={pageData?.banner}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isLoading}
        />
      )}

      {activeTab === "About Intro" && (
        <AboutIntro
          aboutIntroData={pageData?.about}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isLoading}
        />
      )}

      {activeTab === "Why Choose Us" && (
        <WhyChooseUs
          whyChooseUsData={pageData?.whyChooseUs}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isLoading}
        />
      )}

      {activeTab === "Mission" && (
        <MissionSection
          missionData={pageData?.mission}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isLoading}
        />
      )}

      {activeTab === "Vision" && (
        <VisionSection
          visionData={pageData?.vision}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isLoading}
        />
      )}
    </div>
  );
};

export default AboutTabs;